var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar"},[_c('font-awesome-icon',{attrs:{"icon":"coffee"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }